import { createAction } from 'typesafe-actions';

export const setLoading = createAction('SET_LOADING', (value: boolean) => value)<boolean>();
